/**
 * =============================================================================
 * main.js — ENTRY POINT APLIKASI
 * =============================================================================
 * File ini dipanggil dari index.html (script type="module").
 * Tugasnya:
 *   1) Membuat engine balapan (RaceEngine)
 *   2) Membuat UI (UIController)
 *   3) Menjalankan animasi preview kartu di menu
 *   4) Menangani error init agar user tidak melihat layar kosong
 * =============================================================================
 */

/* Wajib: import CSS agar Vite memasukkan styles.css ke build production */
import '../css/styles.css';

import { RaceEngine } from './race.js';
import { UIController } from './ui.js';
import { drawAntPreview } from './ant.js';

/**
 * init()
 * ---------------------------------------------------------------------------
 * Fungsi utama yang dijalankan saat halaman siap.
 * Menghubungkan engine + UI ke elemen #app.
 */
function init() {
  /* Ambil root DOM tempat seluruh game digambar */
  const root = document.getElementById('app');
  if (!root) {
    console.error('[Ant Race] #app not found');
    return;
  }

  try {
    /*
     * Canvas dummy dulu — UIController nanti mengganti ke #game-canvas
     * lewat engine.attachCanvas(...)
     */
    const engine = new RaceEngine(document.createElement('canvas'));

    /* Bangun seluruh layar menu / race / results + event handler */
    const ui = new UIController(root, engine);

    /*
     * Frame berikutnya: pastikan ukuran canvas benar,
     * lalu hilangkan splash "Menyiapkan arena..."
     */
    requestAnimationFrame(() => {
      engine.resize();
      ui.bootDone();
    });

    /*
     * Idle life on menu previews
     * Setiap ~380ms redraw 1 kartu peserta acak agar animasi kaki/antena hidup
     * (hanya saat menu aktif)
     */
    setInterval(() => {
      if (!ui.els.menu?.classList.contains('active')) return;

      const cards = ui.els.grid?.querySelectorAll('.ant-card');
      if (!cards?.length || !ui.participants.length) return;

      const idx = Math.floor(Math.random() * ui.participants.length);
      const canvas = cards[idx]?.querySelector('canvas');

      if (canvas && ui.participants[idx]) {
        drawAntPreview(canvas, ui.participants[idx]);
      }
    }, 380);
  } catch (err) {
    /* Tampilkan pesan error ramah jika init gagal */
    console.error('[Ant Race] init failed', err);
    root.innerHTML = `<div style="padding:24px;font-family:system-ui;color:#fff;background:#1a2e1f;min-height:100vh">
      <h1>Ant Race</h1>
      <p>Gagal memuat game. Refresh halaman.</p>
      <pre style="opacity:.7;white-space:pre-wrap">${String(err)}</pre>
    </div>`;
  }
}

/* ---------------------------------------------------------------------------
 * Bootstrap: tunggu DOM siap, lalu panggil init()
 * --------------------------------------------------------------------------- */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
